export default {
  title: 'Fechar Disponibilidade',
  close_availabilities_form: {
    date_range: {
      label: 'Selecionar uma Data e hora.',
    },
  },
  reason: {
    label: 'Adicionar um motivo (opcional)',
    placeholder: 'Inserir descrição...',
  },
  recurring: {
    label: 'Recorrente anualmente',
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
    add: '+ Adicionar Exceção',
    reactivate: 'Reativar',
  },
  reservations: {
    title: 'Reservas',
    description: 'Pretende adicionar a exceção de horário às reservas?',
    add: 'Adicionar',
    cancel: 'Cancelar',
  },
  projects: {
    online_shop: 'Loja Online',
    reservations: 'Reservas',
    storefront: 'Storefront',
  },
  success_messages: {
    reservation_updated: 'Exceção de horário adicionada com sucesso',
  },
  error_messages: {
    date_range_required: 'Selecione um intervalo de datas.',
    creation_failed: 'Falha ao criar exceção',
    overlapping_schedule_exception: 'Já tem uma exceção de horário para esse intervalo de tempo',
    merge_schedule_exceptions:
      'A seguinte exceção de horário {{oldDate}} será fundida com {{newDate}}. Também pode atualizar o intervalo de datas para {{oldDate}}.',
  },
};
